import { isArray } from './is-array'

export function isArrayWithData<T>(value?: T[]) {
  if (!value) {
    return false
  }

  return isArray(value) && value?.length > 0
}
